import * as React from "react";
import { createStyles, Grid, Theme, withStyles } from "@material-ui/core";
import Logo from "./Logo";
import ThirdPartyCustomer from "./third_party/ThirdPartyCustomer";

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginLeft: spacing(16),
      marginRight: spacing(16),
    },
  });

const Page = (props: any) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={10} justifyContent="center" alignItems="stretch">
        <Logo />
        <ThirdPartyCustomer
          location={props.location}
          history={props.history}
          match={props.match}
          staticContext={props.staticContext}
        />
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Page);
